import { message } from "antd";
import { useCallback, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  completeTask,
  setDraftDialogIndex,
  setDraftDialogPlay,
  updateSegment,
} from "store/bailiff/task/dialog/draft_dialog.action";
import {
  draftDialogDetailSelector,
  draftDialogIndexSelector,
} from "store/bailiff/task/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useDialogUpdate = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const detail = useSelector(draftDialogDetailSelector);
  const index = useSelector(draftDialogIndexSelector);
  const sentences = detail?.sentences || [];
  // -------------------------- FUNCTION ------------------------

  // hoàn thành task.
  const handleComplete = useCallback(() => {
    setLoading(true);
    dispatch(
      completeTask((res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success(
            "Chúc mừng bạn! Bạn đã hoàn thành nhiệm vụ  🎉 🎉 🎉",
          );
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  }, [dispatch]);

  // handle next.
  const handleMove = useCallback(() => {
    const valids = sentences?.length - 1;
    // nếu vailids.
    if (index < valids) {
      const next = index + 1;
      dispatch(setDraftDialogIndex(next));
    }

    // nếu chạm ngưỡng.
    if (index >= valids) {
      handleComplete();
    }
  }, [dispatch, handleComplete, index, sentences?.length]);

  // update segment.
  const handleUpdateSegment = ({ content, slot }) => {
    if (content === "" || !content)
      return message.info("Không được xoá nội dung hội thoại!");
    //loading
    setLoading(true);

    // update
    const update = {
      text: content,
      slot,
    };

    dispatch(setDraftDialogPlay(false));
    dispatch(
      updateSegment({ update }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          // move next index.
          message.success("Chỉnh sửa thành công!");
          handleMove();
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleUpdateSegment };
};
